import { useEffect } from 'react';

const useRecaptcha = (isEnabled, siteKey) => {
    useEffect(() => {
        if (!isEnabled || !siteKey) return;

        const scriptUrl = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;

        script.onload = () => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => {
                    console.log('reCAPTCHA is ready');
                });
            }
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isEnabled, siteKey]);
};

export default useRecaptcha;
